<template>
    <div class="sw-modal">
        <div v-click-outside="close" v-on:click="menuIndex = -1; showExistingAgents = false"
             class="sw-modal-content configure-whatsapp">

            <div class="row sw-modal-heading">
                <div class="col">
                    <h4><i class="fas fa-comments"></i>Your Branded WhatsApp Account</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <!-- <div class="row">
                    <div class="col-12"> -->

                        <template v-if="isWhatsAppActive">
                            <div class="row">
                                <div class="col-12">
                                    <h5>WhatsApp is active: {{whatsAppBusiness.phoneNumber.phoneNumber}}</h5>
                                    <p>Use WhatsApp to communicate with your guests. <br>
                                       Start by <router-link to="/whatsapp-templates">editing your chat templates</router-link></p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="card mb-4 configure-whatsapp__general-information">
                                        <div class="card-header">
                                            <h6>General Information</h6>
                                        </div>
                                        <div class="card-body">
                                            <div v-if="senderStatus" class="row mb-2">
                                                <div class="col-md-2 col-sm-12 mb-2 configure-whatsapp__general-information__detail">
                                                    <div>Status</div>
                                                    <div>{{senderStatus.status}}</div>
                                                </div>
                                                <div class="col-md-4 col-sm-12 mb-2 configure-whatsapp__general-information__detail">
                                                    <div>Business display name</div>
                                                    <div>{{senderStatus.name}}</div>
                                                </div>
                                                <div class="col-md-3 col-sm-12 mb-2 configure-whatsapp__general-information__detail">
                                                    <div>Quality rating</div>
                                                    <div>{{senderStatus.qualityRating}}</div>
                                                </div>
                                                <div class="col-md-3 col-sm-12 mb-2 configure-whatsapp__general-information__detail">
                                                    <div>Messaging limits</div>
                                                    <div>{{senderStatus.messagingLimit}}</div>
                                                </div>
                                            </div>
                                            <div v-else class="col text-center">
                                                <spinner></spinner>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h5>Settings</h5>
                                </div>
                            </div>
                            <div class="row question">
                                <div class="col-12 question__question">
                                    Guest responses
                                </div>
                                <div class="col-12">
                                    <input type="checkbox" v-model="whatsAppBusiness.settings.whatsAppOnMessageReceived">
                                    WhatsApp me when guest messages are received
                                </div>
                                <div class="col-12">
                                    <div v-if="whatsAppBusiness.settings.whatsAppOnMessageReceived" class="row question ml-4 mb-0">
                                        <div class="col-3 question__question">
                                            Your number:
                                        </div>
                                        <div class="col-9">
                                            <vue-tel-input v-model="whatsAppBusiness.settings.establishmentWhatsAppNumber"
                                                        v-bind:mode="'international'"
                                                        v-bind:enabledCountryCode="true"
                                                        v-bind:preferredCountries="['ZA']"
                                                        v-bind:autoFormat="false"
                                                        v-bind:defaultCountry="'ZA'"
                                                        v-on:input="onTelephoneNumberChanged"
                                                        v-on:open="onTelephoneDropdownToggle(true)"
                                                        v-on:close="onTelephoneDropdownToggle(false)">
                                                <template v-slot:arrow-icon>
                                                    <span>{{ isTelephoneDropdownOpen ? '▲' : '▼' }}</span>
                                                </template>
                                            </vue-tel-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-1">
                                    <input type="checkbox" v-model="whatsAppBusiness.settings.emailOnMessageReceived">
                                    Email me when guest messages are received
                                </div>
                            </div>
                            <div class="row question">
                                <div class="col-12 question__question">
                                    Away message
                                </div>
                                <div class="col-12">
                                    <input type="checkbox" v-model="whatsAppBusiness.settings.useAwayMessage">
                                    Send away message
                                </div>
                            </div>
                            <div v-if="whatsAppBusiness.settings.useAwayMessage" class="row question ml-4">
                                <div class="col-12 question__question">
                                    Message
                                </div>
                                <div class="col-12">
                                    <textarea v-model="whatsAppBusiness.settings.awayMessage" 
                                              placeholder="Thank you for your message. We're unavailable right now, but will respond as soon as possible."
                                              class="long-question"></textarea>
                                </div>
                            </div>
                        </template>

                        <template v-else>

                            <template v-if="!startedRegistration">
                                <div class="row">
                                    <div class="col-12 mb-4">
                                        <div class="configure-whatsapp__whatsapp-logo">
                                            <i class="fab fa-whatsapp"></i> + You
                                        </div>
                                        <h5 class="text-center mb-2">Automate messaging via your branded WhatsApp Account</h5>
                                        <ul>
                                            <li><b>Save</b> a lot of <b>time</b></li>
                                            <li><b>No</b> more <b>loading contacts</b> manually</li>
                                            <li><b>Never forget</b> to send a message</li>
                                            <li><b>Improve</b> response times and <b>customer satisfaction</b></li>
                                            <li>You still reply to guest questions - <b>maintain the human element</b></li>
                                            <li>Not sure when the guest is staying? No problem, <b>booking details</b> are a click away</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-4">
                                        <h5 class="text-center mb-2">Is there a cost?</h5>
                                        <p>We use the WhatsApp Business API and there are costs associated with messaging and phone 
                                            number usage. We allocate 10% of your monthly subscription to a communications budget, so you will 
                                            likely not incur any additional costs for this premium feature.</p>
                                        <p>We charge 15c (ZAR) to start a conversation, and 15c (ZAR) for messages in and out. If you would
                                            like to use WhatsApp a lot, simply top up your communication credit.
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-4">
                                        <h5 class="text-center mb-2">3 steps to automating WhatsApp</h5>
                                        <ol>
                                            <li>Book a time with our <b>support</b> team to <b>assist with linking & setup</b></li>
                                            <li><b>Link</b> your <b>WhatsApp Business Account</b> (with our support team)</li>
                                            <li>Edit <b>chat templates</b> and create <b>WhatsApp Automations</b></li>
                                        </ol>
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="card mb-4 configure-whatsapp__embedded-signup">
                                            <div class="card-header">
                                                <h6>Step 1: Book a timeslot with BetterGuest support</h6>
                                                <i v-if="isWhatsAppSigningUp" class="fas fa-check text-success"></i>
                                                <i v-else class="fas fa-hourglass-start"></i>
                                            </div>
                                            <div v-if="isWhatsAppInitiated" class="card-body" v-bind:class="{ 'card-body--disabled' : isWhatsAppActive }">
                                                <div class="row mb-3 mt-1">
                                                    <div class="col">
                                                        <div class="alert alert-info">
                                                            <i class="fas fa-info-circle"></i>
                                                            The only way to activate WhatsApp, is live in a conversation with our support team.
                                                        </div>
                                                        <ul>
                                                            <li>Our support team have been notified and will be in touch</li>
                                                            <!-- <li>You can also contact us on <b>+27 21 762 1409</b></li> -->
                                                            <li>You can also <a href="mailto:support@betterguest.io">email us</a> at <b>support@betterguest.io</b></li>
                                                            <li>If you don't have a <b>Facebook account</b>, 
                                                                <a href="https://www.facebook.com/r.php" target="_blank">set up a Facebook account now</a> (saves time later)</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div v-if="!isWhatsAppSigningUp" class="row mb-3 mt-1">
                                                    <div class="col text-center alert alert-success">
                                                        Please book a time with our support team
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="card mb-4 configure-whatsapp__embedded-signup">
                                            <div class="card-header">
                                                <h6>Step 2: Link your WhatsApp Business Account</h6>
                                                <i class="fas fa-hourglass-start"></i>
                                            </div>
                                            <div v-if="isWhatsAppSigningUp" class="card-body" v-bind:class="{ 'card-body--disabled' : isWhatsAppActive }">
                                                <div class="row mb-3 mt-1">
                                                    <div class="col">
                                                        <div class="alert alert-info">
                                                            <i class="fas fa-info-circle"></i>
                                                            Please keep this window open while you create or select your WhatsApp Business Account
                                                        </div>
                                                        <ul>
                                                            <li>Use the "Login with Facebook" button below to be guided through linking your Meta
                                                            and WhatsApp Business Accounts.</li>
                                                            <li>If you don't have either account, you will have a
                                                            chance to create them.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row mb-2 mt-2">
                                                    <div class="col text-center">
                                                        <!--                                        <button class="btn btn-primary">Login with Facebook</button>-->
                                                        <button v-on:click="launchEmbeddedSignup()" style="background-color: #1877f2; border: 0; border-radius: 4px; color: #fff; cursor: pointer; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; height: 40px; padding: 0 24px;">
                                                            Login with Facebook
                                                        </button>
                                                        <br>
                                                        You will be directed to Facebook to set up WhatsApp in a popup window.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    <!-- </div>
                </div> -->

            </div>
            <div class="sw-modal-actions pr-4 pl-4">
                <div v-if="infoMessage" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                    {{infoMessage}}
                </div>
                <div v-show="(updating || loading) && !success">
                    <Spinner/>
                </div>
                <div class="row" v-show="!(updating || loading) && !success">
                    <div class="col-12 text-center">
                        <button class="btn btn-secondary" v-on:click="close">Close</button>
                        <button v-if="!error && !startedRegistration" class="btn btn-primary" v-on:click.stop="startWhatsAppSetup()">Start</button>
                        <button v-if="!error && isWhatsAppActive" class="btn btn-primary" v-on:click.stop="updateWhatsAppBusinessSettings()">Save</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Spinner from '../Spinner.vue'

    import {whatsAppMixin} from '../../mixins/WhatsAppMixin'

    const VueTelInput = () =>
        Promise.all([
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css')
        ]).then(([{VueTelInput}]) => VueTelInput)

    export default {
        name: 'ConfigureWhatsApp',
        components: {
            Spinner,
            VueTelInput
        },
        mixins: [whatsAppMixin],
        props: {
            establishment: Object
        },
        data: function () {
            return {
                senderStatus: null,
                isTelephoneDropdownOpen: false,
                loading: true,
                updating: false,
                infoMessage: null,
                success: null,
                error: null,
            }
        },
        computed: {
            startedRegistration: function() {
                return this.whatsAppBusiness;
            },
        },
        methods: {
            startWhatsAppSetup: async function() {
                console.log("start WhatsApp setup");
                this.loading = true;
                this.error = false;
                try {
                    let response = await this.$http.post('/guest-management/v1/establishments/' + this.establishment.reference + '/whatsapp/enable');
                    this.whatsAppBusiness = response.data;
                    console.log(response);
                } catch (error) {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem enabling WhatsApp status. Please try again.";
                    }
                } finally {
                    this.loading = false;
                }
            },
            loadFacebookSDK: async function(document, scriptTagName, id) {
                let jsElement,
                        facebookParentElement = document.getElementsByTagName(scriptTagName)[0];
                if (document.getElementById(id)) {
                    return;
                }
                jsElement = document.createElement(scriptTagName);
                jsElement.id = id;
                jsElement.src = "https://connect.facebook.net/en_US/sdk.js";
                facebookParentElement.parentNode.insertBefore(jsElement, facebookParentElement);
            },
            initFacebook: async function() {
                window.fbAsyncInit = function() {
                    window.FB.init({
                        appId: '413606724794353', // Your Meta App ID
                        autoLogAppEvents: true,
                        xfbml: true,
                        version: 'v21.0' 
                    });
                };
            },
            launchEmbeddedSignup: async function() {
                this.infoMessage = "Please do not close this window while we set up WhatsApp.";
                window.FB.login(
                        function (response) {
                            // Since you are using Twilio's APIs, you do not need to do anything with the response here.
                            console.log(response);
                        },
                        {
                            config_id: "359425687111589",
                            auth_type: "rerequest", // avoids "user is already logged" in errors if users click the button again before refreshing the page
                            response_type: "code",
                            override_default_response_type: true,
                            extras: {
                                sessionInfoVersion: 3, // required to get WABA ID
                                // leave below commented for now, you will need to replace this once your app is approved by Meta
                                setup: {
                                    solutionID: "1019814296591566",
                                }
                            }
                        }
                );
            },
            embeddedSignupInfoListener: async function(event) {
                if (event.origin !== "https://www.facebook.com") return;
                try {
                    const data = JSON.parse(event.data);
                    if (data.type === "WA_EMBEDDED_SIGNUP") {

                        // if user finishes the Embedded Signup flow and the popup window closes
                        if (data.event === "FINISH"|| data.event === "FINISH_ONLY_WABA") {
                            const { phone_number_id, waba_id } = data.data;
                            console.log(data);
                            console.log({ phone_number_id, waba_id });
                            // For now, you do not need to do anything here. Once App Review has been completed, then you
                            // will pass this data to your backend service and use Twilio's Senders API to register the number.
                            this.registerWhatsAppBusinessID(waba_id, this.whatsAppPhoneNumber);

                        // if user cancels the Embedded Signup flow
                        } else if (data.event === 'CANCEL') {
                            this.infoMessage = null;
                            const {current_step} = data.data;
                            console.warn('Cancel at ', current_step);

                        // if user reports an error during the Embedded Signup flow
                        } else if (data.event === 'ERROR') {
                            const {error_message} = data.data;
                            this.infoMessage = error_message;
                            console.error('error ', error_message);
                        }
                    }
                } catch (error) {
                    console.error('Error parsing Embedded Signup data', error);
                    console.log('Non JSON Responses', event.data);
                    this.infoMessage = 'Error parsing Embedded Signup data';
                    return;
                }
            },
            registerWhatsAppBusinessID: async function(wabaId) {
                this.infoMessage = "Registering up your WhatsApp Business Account in BetterGuest.";
                const body = {
                    wabaId: wabaId
                }
                this.$http.post('/guest-management/v1/establishments/' + this.establishment.reference + '/whatsapp/register', body,
                        {'axios-retry': {retries: 0}}
                ).then(response => {
                    console.log(response);
                    this.success = true;
                    this.infoMessage = "Success! Your WhatsApp Business Account is set up. You can now edit your chat templates and create WhatsApp Automations.";
                    setTimeout(async () => {
                        this.success = false;
                        this.infoMessage = null;
                        await this.fetchWhatsApp();
                        if (this.isWhatsAppActive) {
                            await this.fetchSenderStatus();
                        } 
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem registering your WhatsApp account. Please contact support.";
                    }
                });
            },
            fetchSenderStatus: async function () {
                this.loading = true;
                this.error = false;
                try {
                    let response = await this.$http.get('/guest-management/v1/establishments/' + this.establishment.reference + '/whatsapp/sender-status');
                    this.senderStatus = response.data;
                } catch (error) {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem checking the sender status. Please try again.";
                    }
                } finally {
                    this.updating = false;
                }
            },
            onTelephoneDropdownToggle: function (open) {
                this.isTelephoneDropdownOpen = open;
            },
            onTelephoneNumberChanged: function (number, phoneObject) {
                this.whatsAppBusiness.settings.establishmentWhatsAppNumber = phoneObject.number;
            },
            updateWhatsAppBusinessSettings: async function () {
                this.updating = true;
                this.error = false;
                try {
                    let response = await this.$http.put('/guest-management/v1/establishments/' + this.establishment.reference + '/whatsapp/settings', this.whatsAppBusiness.settings);
                    this.whatsAppBusiness.settings = response.data;
                    this.success = true;
                    this.infoMessage = "WhatsApp Business settings updated successfully.";
                } catch (error) {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem updating the WhatsApp Business settings. Please try again.";
                    }
                } finally {
                    setTimeout(() => {
                        this.updating = false;
                        this.success = false;
                    }, 2000);
                }
            },
            close: function () {
                console.log("close configure WhatsApp");
                this.$root.$emit('finished-editing-whatsapp');
            },
        },
        mounted: async function () {
            await this.fetchWhatsApp(this.establishment.reference);
            if (this.isWhatsAppActive) {
                await this.fetchSenderStatus();
            } else {
                await this.loadFacebookSDK(document, "script", "facebook-js-sdk");
                await this.initFacebook();
            }

            this.loading = false;
            window.addEventListener("message", this.embeddedSignupInfoListener);
        },
        beforeDestroy () {
            window.removeEventListener("message", this.embeddedSignupInfoListener);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/layout/_forms.scss";
    @import "../../styles/components/_modal.scss";
    @import "../../styles/components/_configure_whatsapp.scss";
    @import "../../styles/components/_edit_form_component.scss";
    @import "../../styles/components/_question_answer.scss";
</style>
